export default __webpack_public_path__ + "static/media/jEUR.d7bf0ecf.png";